import { cn } from '@commenda/utils';
import React from 'react';

import { Badge, type BadgeProps } from '../../Badge';
import { DATA_GRID_CELL_MAX_VISIBLE_BADGES } from '../constants';
import { DataGridAlign } from '../types';
import { getDataGridJustifyClass } from '../utils';

export interface DataGridCellBadgeItem {
  key: string;
  label: React.ReactNode;
  variant?: BadgeProps['variant'];
}

export interface DataGridCellBadgeProps {
  badges: DataGridCellBadgeItem[];
  maxVisible?: number;
  align?: DataGridAlign;
  className?: string;
}

const DataGridCellBadge = ({
  badges,
  maxVisible = DATA_GRID_CELL_MAX_VISIBLE_BADGES,
  align = 'left',
  className,
}: DataGridCellBadgeProps) => {
  const visibleBadges = badges.slice(0, maxVisible);
  const hiddenCount = badges.length - visibleBadges.length;

  return (
    <div
      className={cn(
        'flex w-full items-center gap-md',
        getDataGridJustifyClass(align),
        className
      )}
    >
      {visibleBadges.map((badge) => (
        <Badge key={badge.key} size="sm" variant={badge.variant}>
          {badge.label}
        </Badge>
      ))}
      {hiddenCount > 0 ? (
        <Badge size="sm" variant="gray">
          {`+${hiddenCount}`}
        </Badge>
      ) : null}
    </div>
  );
};

export { DataGridCellBadge };
